import './newsItems.scss';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import * as moment from 'moment';
import { memo, useEffect, useState } from 'react';
import { DateInput } from 'semantic-ui-calendar-react';
import { buildOptionsFromDict, buildOptionsFromStrings } from '../../utils/buildOptionsFromArray';
import {
  Button,
  Card,
  Dropdown,
  Icon,
  Image,
  Menu,
  Table,
  Form,
  Pagination,
  Segment,
  Label,
  Confirm,
} from 'semantic-ui-react';
import { defaultImages } from '../../constants';
import PageContainer from '../common/PageContainer';
import CloneArticleModal from './CloneArticleModal';
import { SelectField } from '../common/FormFields';
import * as api from './../../api/postApi';

const ContentSearchPage = ({
  query,
  getNewsItemsSuccess,
  roles,
  newsItems,
  getNewsItems,
  setNewsItemQuery,
  isEditorOrAdmin,
  authors,
  getAuthors,
  sites,
  pageTitle,
  pageIcon,
  contentType,
  resultsPageCount,
  addItemModal,
  columns = ['photo', 'headline', 'date', 'author', 'city', 'status', 'sections'],
  searchFields = [
    { name: 'headline', label: 'Headline' },
    { name: 'city', label: 'City' },
    { name: 'status', label: 'Status' },
    { name: 'section', label: 'Section' },
    { name: 'time', label: 'Publication date' },
    { name: 'author', label: 'Author' },
    { name: 'promoted', label: 'Promoted' },
    { name: 'scheduled', label: 'Scheduled' },
  ],
}) => {
  useEffect(() => getNewsItemsSuccess([], 0, 0), []);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const dateLabel = 'All Time';
  const [confirm, setConfirm] = useState(false);

  const getField = name => searchFields.find(field => field.name === name);

  const original = {
    limit: 10,
    offset: 0,
    site: '',
    status: '0,1,2,5',
    start_date: dateLabel,
    end_date: dateLabel,
    author_id: '',
    author_name: '',
    occurrence: '',
    showPromoted: false,
    future: false,
    q: '',
    type: contentType,
    time: dateLabel,
    section: '',
    sort: { field: 'updated_ts', direction: 'DESC' },
  };

  useEffect(() => {
    setNewsItemQuery(original);
    getNewsItems(original);
    getAuthors();
    setLoading(true);
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [newsItems]);

  const status = {
    All: '0,1,2,5',
    Live: 0,
    Draft: 5,
    Deleted: 4,
  };

  const dates = ['Today', 'Last 7 Days', 'Last 30 Days', 'This Year', 'All Time'];
  const sections = [
    '',
    'Restaurants + Bars',
    'City Life',
    'Entertainment',
    'Travel',
    'Real Estate',
    'Arts',
    'Society',
    'Home + Design',
    'Fashion + Beauty',
    'Innovation',
    'Sports',
  ];

  const sectionOptions = buildOptionsFromStrings(sections);
  const dateOptions = buildOptionsFromStrings(dates);
  const stages = buildOptionsFromDict(status).filter(s => s.text !== 'Deleted');

  const handlePageChange = ({ activePage }, formik) => {
    setActivePage(activePage);
    const offset = 10 * (activePage - 1);
    formik.setFieldValue('offset', offset);
    formik.handleSubmit();
  };

  const handleSubmit = async currentQuery => {
    setLoading(true);
    const { future, ...current } = currentQuery;
    const type = contentType;
    if (future) {
      getNewsItems({ ...current, future, type });
    } else {
      getNewsItems({ ...current, type });
    }
    setNewsItemQuery({ ...current, future, type });
  };

  const primarySections = [
    'RESTAURANTS + BARS',
    'CITY LIFE',
    'ENTERTAINMENT',
    'FASHION + BEAUTY',
    'TRAVEL',
    'REAL ESTATE',
    'ARTS',
    'SOCIETY',
    'HOME + DESIGN',
    'INNOVATION',
    'SPORTS',
    'EVENTS',
  ];

  const SortArrow = ({ title, field, formik }) => {
    const direction = getSortForField(field, formik);

    if (direction === 'ASC') {
      return (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            formik.setFieldValue('sort', { field, direction: 'DESC' });
            formik.handleSubmit();
          }}
        >
          {title}
          <Icon name="chevron up" />
        </span>
      );
    }
    if (direction === 'DESC') {
      return (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            formik.setFieldValue('sort', { field, direction: 'ASC' });
            formik.handleSubmit();
          }}
        >
          {title}
          <Icon name="chevron down" />
        </span>
      );
    }
    return (
      <span
        style={{ cursor: 'pointer' }}
        onClick={() => {
          formik.setFieldValue('sort', { field, direction: 'DESC' });
          formik.handleSubmit();
        }}
      >
        {title}
        <Icon name="sort" />
      </span>
    );
  };

  const getSortForField = (field, formik) => {
    if (formik.values.sort.field !== field) return;
    return formik.values.sort.direction;
  };

  const getLabelForItem = item => {
    if (item.status === 'Live') {
      return <Label size="mini" content={item.status} color={'green'} />;
    }
    if (item.status === 'Draft' && item.scheduled_at) {
      return <Label size="mini" content={'Scheduled'} color={'blue'} />;
    }

    return <Label size="mini" content={'Draft'} color={'yellow'} />;
  };

  const getPublishDateForItem = item => {
    if (item.status === 'Live' && item.is_event) {
      return item?.upcoming?.map((o, idx) => <div key={idx}>{o}</div>);
    }
    if (item.status === 'Live') {
      return item.formatted_date;
    }

    if (item.status === 'Draft' && item.scheduled_at) {
      return item.scheduled_at;
    }

    return '(None)';
  };

  const SegementMemo = memo(({ formik }) => (
    <Segment loading={loading} basic style={{ padding: 0, minHeight: '60vh' }}>
      <div className="articles-layout">
        <div>
          <Table className="content-search-page-table" size="small" padded={false} compact="very" fixed>
            <Table.Header fullWidth>
              <Table.Row>
                <Table.HeaderCell style={{ width: 30 }}></Table.HeaderCell>
                {columns.includes('photo') && <Table.HeaderCell style={{ width: 100 }}>Photo</Table.HeaderCell>}
                <Table.HeaderCell width={3}>
                  <SortArrow field="headline" formik={formik} title={getField('headline').label} />
                </Table.HeaderCell>
                <Table.HeaderCell width={2}>
                  <SortArrow
                    field="created_ts"
                    formik={formik}
                    title={contentType === 'event' ? 'Occurrences' : 'Publish Date'}
                  />
                </Table.HeaderCell>

                {columns.includes('author') && (
                  <Table.HeaderCell width={2}>
                    Author
                    {/* <SortArrow field={'author'} formik={formik} title={'Author'} /> */}
                  </Table.HeaderCell>
                )}
                <Table.HeaderCell width={2}>
                  <SortArrow field={'city'} formik={formik} title={'City'} />
                </Table.HeaderCell>
                {columns.includes('author') && <Table.HeaderCell width={2}>Sections</Table.HeaderCell>}
                <Table.HeaderCell width={1}>
                  <SortArrow field={'status'} formik={formik} title={'Status'} />
                </Table.HeaderCell>
                <Table.HeaderCell width={2}>
                  <SortArrow field={'updated_ts'} formik={formik} title={'Last Updated'} />
                </Table.HeaderCell>
                <Table.HeaderCell width={2}>
                  <SortArrow field={'last_updated_by'} formik={formik} title={'Last Updated By'} />
                </Table.HeaderCell>
                <Table.HeaderCell width={1}>Views</Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={1}>
                  Actions
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {newsItems?.map((item, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell>
                    {item.status === 'Live' && (
                      <Button
                        size="mini"
                        primary
                        basic
                        style={{ padding: 3 }}
                        icon={<Icon name="chain" />}
                        onClick={() => window.open(item.post_url, '_blank')}
                      />
                    )}
                    {item.status === 'Draft' && (
                      <Button
                        size="mini"
                        primary
                        basic
                        style={{ padding: 3 }}
                        icon={<Icon name="chain" />}
                        onClick={() => window.open(item.post_url + '?draft=1&clear=cache', '_blank')}
                      />
                    )}
                  </Table.Cell>
                  {columns.includes('photo') && (
                    <Table.Cell>
                      <Image
                        src={item.image_url || defaultImages.PHOTO_PLACEHOLDER}
                        size="tiny"
                        onClick={() => {
                          if (item.status === 'Live' && !isEditorOrAdmin) return;
                          window.open(item.editor_url, '_blank');
                        }}
                        style={{ height: 50 }}
                      />
                    </Table.Cell>
                  )}
                  <Table.Cell>
                    {item.status === 'Live' && isEditorOrAdmin && (
                      <a target="_blank" rel="noreferrer" href={item.editor_url}>
                        {item.headline || 'No Title'}
                      </a>
                    )}
                    {item.status === 'Live' && !isEditorOrAdmin && (item.headline || 'No Title')}
                    {item.status === 'Draft' && (
                      <a target="_blank" rel="noreferrer" href={item.editor_url}>
                        {item.headline || 'No Title'}
                      </a>
                    )}
                  </Table.Cell>
                  <Table.Cell>{getPublishDateForItem(item)}</Table.Cell>

                  {columns.includes('author') && <Table.Cell>{item.author}</Table.Cell>}
                  <Table.Cell>{item.city}</Table.Cell>

                  {columns.includes('author') && (
                    <Table.Cell>
                      {item.sections
                        ?.map(s => s.name)
                        .filter(s => s !== 'HOME')
                        .filter(s => s !== 'PROMOTED')
                        .filter(s => primarySections.includes(s?.toUpperCase()))
                        .sort()
                        .map((page, idx) => (
                          <div key={idx}>{page}</div>
                        ))}
                    </Table.Cell>
                  )}
                  <Table.Cell>{getLabelForItem(item)}</Table.Cell>
                  <Table.Cell>{item.updated_date}</Table.Cell>
                  <Table.Cell>{item.last_updated_by}</Table.Cell>
                  <Table.Cell>
                    {(roles.includes('admin') || roles.includes('editor')) && (
                      <>
                        <div style={{ marginBottom: 5 }}>Total: {item.total_views}</div>
                        {/* <div style={{ marginBottom: 5 }}>Last hour: {item.views_last_hours}</div> */}
                      </>
                    )}
                  </Table.Cell>
                  <Table.Cell textAlign="center" style={{ overflowX: 'unset', overflowY: 'unset' }}>
                    <Dropdown
                      icon="options"
                      button
                      compact
                      labeled
                      pointing="right"
                      style={{ zIndex: 9999 }}
                      closeOnChange
                    >
                      <Dropdown.Menu>
                        <CloneArticleModal article={item} />
                        <Dropdown.Item content="Set Homepage Hero" icon="star" />
                        {isEditorOrAdmin && (item.status === 'Draft' || item.type === 'event') && (
                          <>
                            <Dropdown.Item content="Delete" icon="trash" onClick={() => setConfirm(item?.id)} />
                            <Confirm
                              open={confirm === item?.id}
                              content={`Are you sure you want to delete: \n ${item.headline}?`}
                              onCancel={() => setConfirm(null)}
                              onConfirm={() => {
                                api.deleteArticle(item.id).then(() => {
                                  formik.handleSubmit();
                                });
                              }}
                            />
                          </>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </div>
    </Segment>
  ));

  const FormMemo = memo(({ formik }) => (
    <Card fluid>
      <Card.Content style={{ paddingTop: 5, paddingBottom: 0, paddingLeft: 10, paddingRight: 10 }}>
        <Form className="ui form mini" inline="true">
          <Form.Group width="equal">
            {getField('headline') && (
              <Form.Field width={3}>
                <strong>{getField('headline').label}</strong>
                <Form.Input
                  icon="search"
                  name="q"
                  formik={formik}
                  value={formik.values.q}
                  onChange={(e, { value }) => formik.setFieldValue('q', value)}
                />
              </Form.Field>
            )}

            {getField('city') && (
              <Form.Field width={3}>
                <strong>City</strong>
                <Form.Dropdown
                  name="site"
                  className="time-dropdown"
                  value={formik.values.site}
                  onChange={(e, { value }) => {
                    formik.setFieldValue('site', value);
                    formik.setFieldValue('offset', 0);
                    setActivePage(1);
                    formik.handleSubmit();
                  }}
                  placeholder="All"
                  fluid
                  selection
                  clearable
                  search
                  options={sites ? [{ key: ' ', value: '', text: 'All' }, ...sites.filter(s => s.key)] : []}
                />
              </Form.Field>
            )}

            {getField('status') && (
              <Form.Field width={2}>
                <strong>Status</strong>
                <Form.Dropdown
                  selection
                  name="status"
                  value={formik.values.status}
                  onChange={(e, { value }) => {
                    formik.setFieldValue('status', value);
                    formik.setFieldValue('offset', 0);
                    setActivePage(1);
                    formik.handleSubmit();
                  }}
                  fluid
                  clearable
                  search
                  options={stages || []}
                />
              </Form.Field>
            )}

            {getField('section') && (
              <Form.Field width={3}>
                <strong>Section</strong>
                <Form.Dropdown
                  selection
                  name="section"
                  clearable
                  className="time-dropdown"
                  value={formik.values.section}
                  onChange={(e, { value }) => {
                    formik.setFieldValue('section', value);
                    formik.setFieldValue('offset', 0);
                    setActivePage(1);
                    formik.handleSubmit();
                  }}
                  fluid
                  search
                  options={sectionOptions || []}
                />
              </Form.Field>
            )}

            {getField('time') && (
              <Form.Field width={3}>
                <strong>Publication Date</strong>
                <Form.Dropdown
                  selection
                  name="time"
                  clearable
                  className="time-dropdown"
                  value={formik.values.time}
                  onChange={(e, { value }) => {
                    formik.setFieldValue('time', value);
                    formik.setFieldValue('start_date', value);
                    formik.setFieldValue('end_date', value);
                    formik.setFieldValue('offset', 0);
                    formik.setFieldValue('sort', { field: 'created_ts', direction: 'DESC' });
                    setActivePage(1);
                    formik.handleSubmit();
                  }}
                  fluid
                  search
                  options={dateOptions || []}
                />
              </Form.Field>
            )}

            {getField('occurrence') && (
              <Form.Field width={3}>
                <strong>Occurrence</strong>
                <DateInput
                  closable={true}
                  name="occurrence"
                  placeholder="Occurrence"
                  popupPosition="bottom center"
                  minDate={moment().format('L')}
                  value={formik.values.occurrence || ''}
                  iconPosition="left"
                  dateFormat="YYYYMMDD"
                  onChange={(e, { value }) => formik.setFieldValue('occurrence', value ?? null)}
                />
              </Form.Field>
            )}

            {getField('author') && (
              <Form.Field width={3}>
                <strong>Author</strong>
                <Form.Dropdown
                  value={formik.values.author_name}
                  fluid
                  name="author_name"
                  clearable
                  selection
                  search
                  options={authors || []}
                  onChange={(e, { value }) => {
                    formik.setFieldValue('author_name', value);
                    formik.setFieldValue('offset', 0);
                    setActivePage(1);
                    formik.handleSubmit();
                  }}
                />
              </Form.Field>
            )}

            {getField('promoted') && (
              <Form.Field>
                <strong>Promoted</strong>
                <Form.Radio
                  checked={formik.values.showPromoted}
                  toggle
                  name="showPromoted"
                  style={{ marginTop: 5 }}
                  onChange={(e, { checked }) => {
                    formik.setFieldValue('showPromoted', checked);
                    formik.setFieldValue('offset', 0);
                    setActivePage(1);
                    formik.handleSubmit();
                  }}
                />
              </Form.Field>
            )}

            {getField('future') && (
              <Form.Field>
                <strong>Scheduled</strong>
                <Form.Radio
                  name="future"
                  checked={formik.values.future}
                  toggle
                  style={{ marginTop: 5 }}
                  onChange={(e, { checked }) => {
                    formik.setFieldValue('future', checked);
                    formik.setFieldValue('offset', 0);
                    setActivePage(1);
                    formik.handleSubmit();
                  }}
                />
              </Form.Field>
            )}

            <Form.Field>
              <Button
                type="submit"
                style={{ marginTop: 20 }}
                content="Submit"
                size="mini"
                positive
                fluid
                onClick={() => handlePageChange({ activePage: 1 }, formik)}
              />
            </Form.Field>

            <Form.Field>
              <Button
                content="Clear"
                fluid
                style={{ marginTop: 20 }}
                size="mini"
                onClick={() => {
                  setNewsItemQuery({ ...original });
                  formik.resetForm();
                  Object.keys(original).forEach(key => {
                    formik.setFieldValue(key, original[key]);
                  });
                  setActivePage(1);
                  formik.handleSubmit();
                }}
              />
            </Form.Field>
          </Form.Group>
        </Form>
      </Card.Content>
    </Card>
  ));

  return (
    <div data-testid="articles-layout">
      <PageContainer>
        <Formik initialValues={query} enableReinitialize onSubmit={handleSubmit}>
          {formik => (
            <>
              <Menu borderless size="mini">
                <Menu.Item header>
                  <Icon name={pageIcon} />
                  {pageTitle}
                </Menu.Item>

                <Menu.Menu position="right">
                  <Menu.Item>{addItemModal}</Menu.Item>
                </Menu.Menu>
              </Menu>

              <FormMemo formik={formik} />

              <SegementMemo formik={formik} />

              <div
                style={{
                  display: 'grid',
                  justifyContent: 'center',
                  gridTemplateColumns: 'auto auto',
                  columnGap: '1rem',
                }}
              >
                <Pagination
                  size="tiny"
                  totalPages={resultsPageCount}
                  activePage={activePage}
                  onPageChange={(e, data) => handlePageChange(data, formik)}
                />

                <SelectField
                  id="limit"
                  size="tiny"
                  name="limit"
                  formik={formik}
                  clearable={false}
                  options={[
                    { key: 10, text: '10', value: 10 },
                    { key: 20, text: '20', value: 20 },
                    { key: 50, text: '50', value: 50 },
                  ]}
                  value={formik.values.limit}
                  cb={formik.handleSubmit}
                  onChange={formik.handleChange}
                />
              </div>
            </>
          )}
        </Formik>
      </PageContainer>
    </div>
  );
};

const mapStateToProps = state => ({
  users: selectors.photos.userOptions(state),
  user: selectors.getUser(state),
  roles: selectors.users.roles(state),
  isEditorOrAdmin: selectors.users.isEditorOrAdmin(state),
  query: selectors.content.query(state),
  authors: selectors.content.authors(state),
  newsItems: selectors.content.newsItems(state),
  count: selectors.content.count(state),
  resultsItemCount: selectors.content.resultsItemCount(state),
  resultsPageCount: selectors.content.resultsPageCount(state),
  sites: selectors.admin.cultureMapSiteOptionsBasic(state),
});

const mapDispatchToProps = dispatch => ({
  getNewsItems: bindActionCreators(actions.content.getNewsItems, dispatch),
  getUsers: bindActionCreators(actions.photos.getUsers, dispatch),
  setNewsItemQuery: bindActionCreators(actions.content.setNewsItemQuery, dispatch),
  setNewsItemPage: bindActionCreators(actions.content.setNewsItemPage, dispatch),
  getNewsItemsSuccess: bindActionCreators(actions.content.getNewsItemsSuccess, dispatch),
  getAuthors: bindActionCreators(actions.content.getAuthors, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentSearchPage);
